import { useState, useRef, useEffect } from "react";

export default function BeforeAfterSlider({ beforeSrc, afterSrc, beforeLabel = "Before", afterLabel = "After" }) {
    const [pos, setPos] = useState(50);
    const wrapRef = useRef(null);
    const draggingRef = useRef(false);

    const updateFromClientX = (clientX) => {
        const el = wrapRef.current;
        if (!el) return;
        const rect = el.getBoundingClientRect();
        const x = Math.max(0, Math.min(clientX - rect.left, rect.width));
        setPos((x / rect.width) * 100);
    };

    useEffect(() => {
        const onMove = (e) => {
            if (!draggingRef.current) return;
            const x = e.touches ? e.touches[0].clientX : e.clientX;
            updateFromClientX(x);
        };
        const onUp = () => {
            draggingRef.current = false;
        };
        window.addEventListener("mousemove", onMove);
        window.addEventListener("touchmove", onMove);
        window.addEventListener("mouseup", onUp);
        window.addEventListener("touchend", onUp);
        return () => {
            window.removeEventListener("mousemove", onMove);
            window.removeEventListener("touchmove", onMove);
            window.removeEventListener("mouseup", onUp);
            window.removeEventListener("touchend", onUp);
        };
    }, []);

    return (
        <div
            ref={wrapRef}
            className="ba-wrap aspect-[4/3] w-full"
            data-testid="before-after-slider"
            onMouseDown={(e) => {
                draggingRef.current = true;
                updateFromClientX(e.clientX);
            }}
            onTouchStart={(e) => {
                draggingRef.current = true;
                updateFromClientX(e.touches[0].clientX);
            }}
        >
            <img src={beforeSrc} alt="Before enhancement" />
            <div className="ba-after-mask" style={{ width: `${pos}%` }}>
                <img src={afterSrc} alt="After enhancement" />
            </div>
            <div className="ba-label ba-label-before">{beforeLabel}</div>
            <div className="ba-label ba-label-after">{afterLabel}</div>
            <div className="ba-handle" style={{ left: `${pos}%` }}>
                <div className="ba-handle-knob">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                        <path d="M9 6l-6 6 6 6" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M15 6l6 6-6 6" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                </div>
            </div>
        </div>
    );
}
